module.exports = "# Extension Activities\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/extensionActivities/extensionActivities.md
// module id = 1514
// module chunks = 2